<!-- Table for attendance status -->
<section>
  <div class="container">
    <h3>部署の勤怠確認</h3>

    <!-- Start filters -->
    <div class="filter-wrapper">
      <!-- search button -->
      <div class="filters">
        <div class="ui icon input">
          <input type="text" [(ngModel)]="search" placeholder="Search..." (keyup.enter)="onSearch($event)">
          <i class="search icon"></i>
        </div>
        <!-- group selection -->
        <sui-select class="selection"
              [placeholder]="'Select group...'"
              [(ngModel)]="selected_group"
              [labelField]="'group_name'"
              [valueField]="'_id'"
              [isSearchable]="searchable"
              (ngModelChange)="onSelectGroup($event)"
              #select *ngIf="groups.length > 0">
            <sui-select-option *ngFor="let group of groups"
                                [value]="group">
            </sui-select-option>
        </sui-select>
      </div>
    <!-- refresh button -->
      <button class="ui icon button" (click)="onRefresh()">
        <i class="refresh icon"></i>
      </button>
    </div>
    <!-- End filters -->

    <div class="ui active centered inline loader" style="margin-top: 30px" *ngIf="isloading; else elseBlock"></div>
    <ng-template #elseBlock>
      <!-- Start table for working employees -->
      <h3>勤務時間中のスタッフ</h3>
      <app-status-table [staffs]="finalData.work"></app-status-table>
      <!-- End table for out employees -->

      <!-- Start table for breaking employees -->
      <h3>休憩時間中のスタッフ</h3>
      <app-status-table [staffs]="finalData.break"></app-status-table>
      <!-- End table for out employees -->

      <!-- Start table for breaking employees -->
      <h3>勤務時間外のスタッフ</h3>
      <app-status-table [staffs]="finalData.out"></app-status-table>
      <!-- End table for out employees -->

      <hr>
      <h3>出勤者と退勤者の一覧</h3>
      <app-timestamp-table></app-timestamp-table>

    </ng-template>

    

  </div>
</section>

<!-- ================================== Table for morning meeting ================================== -->
<!-- <div class="ui floating success message">
  <i class="close icon"></i>
  <div class="header">
    Update successful
  </div>
</div>
<section>
  <div class="container">
    <div class="ui buttons">
      <button class="ui button" [class.active]="!showAllStaffs" (click)="showNoTimeStampStaffs()">出勤打刻のない人</button>
      <button class="ui button" [class.active]="showAllStaffs" (click)="onShowAllStaffs()">全員を表示</button>
    </div>
    <div class="header"></div> -->

    <!-- PC version -->
    <!-- <div class="table-wrapper" *ngIf="!isMobile; else elseblock">
      <table class="ui selectable celled table">
        <thead>
          <tr>
            <th class="one wide"></th>
            <th class="seven wide">欠席者にチェック</th>
            <th class="eight wide">備考</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let meeting of morningMeetings; index as i">
            <td style="text-align: center;">
              <div class="ui fitted checkbox">
                <input type="checkbox" name="absent" [checked]="meeting.absent" (change)="toggleAbsent($event, meeting._id)">
                <label></label>
              </div>
            </td>
            <td>{{meeting.staff && meeting.staff.name? meeting.staff.name : '&nbsp;'}}</td>
            <td class="comment">
              <div class="field">
                <input type="text" name="comment" placeholder="comment..." 
                  [(ngModel)]="meeting.comment" (keyup)="onUpdateComment($event, meeting._id)"
                  #txtComment (keydown.enter)="txtComment.blur()">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="empty-row" *ngIf="morningMeetings.length == 0">
        No data to show
      </div>
    </div> -->

    <!-- Mobile version -->
    <!-- <ng-template #elseblock>
      <div class="data-wrapper">
        <div class="column">
          <div class="header">勤務中</div>
          <div class="data" *ngFor="let staff of statuses.work">{{staff.name? staff.name : '&nbsp;'}}</div>
        </div>
        <div class="column">
          <div class="header">休憩中</div>
          <div class="data" *ngFor="let staff of statuses.break">{{staff.name? staff.name : '&nbsp;'}}</div>
        </div>
        <div class="column">
          <div class="header">就業時間外</div>
          <div class="data" *ngFor="let staff of statuses.out">{{staff.name? staff.name : '&nbsp;'}}</div>
        </div>
        <div class="column">
          <div class="header">休暇</div>
          <div class="data" *ngFor="let staff of statuses.leave">{{staff.name? staff.name : '&nbsp;'}}</div>
        </div>
      </div>
    </ng-template>
  </div>
</section> -->

<!-- <app-morning-meeting [user]="user"></app-morning-meeting> -->

<!-- Modal Template -->
<ng-template let-context let-modal="modal" #modalTemplate>
  <div class="header modal-header" style="background-color: #2F4F4F; color: white; padding: 10px">勤怠ログを出力</div>
  <div class="content">
      <p>期間選択</p>
      <div class="ui left icon input">
        <i class="calendar icon"></i>
        <input suiDatepicker readonly
            [(ngModel)]="_from"
            [pickerMode]="'date'"
            pickerFirstDayOfWeek="0"
            [pickerUseNativeOnMobile]="true">
      </div> ~ 
      <div class="ui left icon input">
        <i class="calendar icon"></i>
        <input suiDatepicker readonly
            [(ngModel)]="_to"
            [pickerMode]="'date'"
            pickerFirstDayOfWeek="0"
            [pickerUseNativeOnMobile]="true">
      </div>
  </div>
  <div class="actions">
      <button class="ui gray button" (click)="modal.deny('denied')">Cancel</button>
      <button class="ui teal button" (click)="modal.approve('approved')" autofocus>OK</button>
  </div>
</ng-template>

